const radiusTokens = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 10,
  '2xl': 12,
  '3xl': 16,
  '3.5xl': 24,
  '4xl': 32,
};

const radius = {
  token: radiusTokens,
  badge: radiusTokens.md,
  input: radiusTokens.md,
  label: radiusTokens.lg,
  banner: radiusTokens.lg,
  card: radiusTokens['2xl'],
  panel: radiusTokens['2xl'],
  modal: radiusTokens['2xl'],
};

export { radius, radiusTokens };
